import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearErrors, singleProductAction, updateProductAction } from "../../../redux/actions/productActions";
import { toast } from "react-toastify";
import Loader from "../../loader/loader";
import { useSearchParams } from "react-router-dom";
import { UPDATE_PRODUCT_RESET } from "../../../redux/constants/productConstants";

const UpdateProduct = () => {


    const dispatch = useDispatch();


    const { loading: singleProductLoading, product, error: singleProductError } = useSelector(state => state.products)


    const { loading, error, message } = useSelector(state => state.productMessage)

    const [scan_code, setScan_code] = useState("");
    const [description, setDescription] = useState("");
    const [unit_case, setUnit_case] = useState("");
    const [department, setDepartment] = useState("");




    const [purchase_qty, setPurchase_qty] = useState(null);
    const [sold_qty, setSold_qty] = useState(null);
    const [adjust_qty, setAdjust_qty] = useState(null);
    const [current_qty, setCurrent_qty] = useState(null);


    const [each_cost, seteach_cost] = useState("");
    const [each_retail, seteach_retail] = useState("");



    const [searchParams] = useSearchParams();

    const id = searchParams.get("id");


    useEffect(() => {
        const Headerlinkks = document.querySelectorAll(".headerLinks");
        const element = document.getElementById("productCatalog");


        Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
        element?.classList.add("activeHeaderLink");

        document.title = `Update Product - Admin Panel`;

    }, []);


    const handleSubmit = (e) => {
        e.preventDefault()



        if (!description) {
            toast.error("Please enter description")
            return
        }
        if (!department) {
            toast.error("Please enter department")
            return
        }

        if (!each_cost || Number(each_cost) < 0) {
            toast.error("Please enter cost")
            return
        }
        console.log(Number(each_retail))

        if (!each_retail || Number(each_retail) < 0) {
            toast.error("Please enter retail")
            return
        }


        if (Number(each_cost) > Number(each_retail)) {
            toast.error("Cost should be less than retail")
            return
        }







        if (!scan_code) {
            toast.error("Please enter scan code")
            return
        }

        if (!scan_code.trim()) return;

        let scan_codeQuery = scan_code.trim();

        // Remove spaces
        scan_codeQuery = scan_codeQuery.replace(/\s/g, "");

        // ❌ Only digits allowed
        if (!/^\d+$/.test(scan_codeQuery)) {
            toast.error("Invalid barcode. Only numbers are allowed.");
            return;
        }

        // ❌ Not allowed more than 12 digits
        if (scan_codeQuery.length > 12) {
            toast.error("Invalid barcode length. Maximum 12 digits allowed.");
            return;
        }

        if (scan_codeQuery.length === 8) {
            if (!/^\d{8}$/.test(scan_codeQuery)) {
                toast.error("Invalid UPC-E format");
            }

            const S = scan_codeQuery[0];           // Number system
            const a = scan_codeQuery[1];
            const b = scan_codeQuery[2];
            const c = scan_codeQuery[3];
            const d = scan_codeQuery[4];
            const e = scan_codeQuery[5];
            const N = scan_codeQuery[6];           // Expansion digit
            // const X = upc[7];        // Old check digit (we will recalc)

            let expanded;

            if (["0", "1", "2"].includes(N)) {
                expanded = `${S}${a}${b}${N}0000${c}${d}${e}`;
            }
            else if (N === "3") {
                expanded = `${S}${a}${b}${c}00000${d}${e}`;
            }
            else if (N === "4") {
                expanded = `${S}${a}${b}${c}${d}00000${e}`;
            }
            else {
                expanded = `${S}${a}${b}${c}${d}${e}0000${N}`;
            }

            // Now calculate new UPC-A check digit (12th digit)
            let sum = 0;
            for (let i = 0; i < 11; i++) {
                const digit = parseInt(expanded[i]);
                sum += (i % 2 === 0) ? digit * 3 : digit;
            }

            const checkDigit = (10 - (sum % 10)) % 10;

            scan_codeQuery = expanded + checkDigit;
        }




        const data = {
            scan_code: scan_codeQuery,
            description,
            unit_case,
            department,
            purchase_qty,
            sold_qty,
            adjust_qty,
            current_qty,
            each_cost,
            each_retail
        }

        dispatch(updateProductAction(id, data))

    }




    useEffect(() => {


        if (error) {
            toast.error(error)
            dispatch(clearErrors())
        }
        if (message) {
            toast.success(message)
            dispatch({ type: UPDATE_PRODUCT_RESET })
        }


    }, [error, message, dispatch])






    useEffect(() => {

        setCurrent_qty((Number(purchase_qty) + Number(sold_qty) + Number(adjust_qty)) || null)


    }, [purchase_qty, sold_qty, adjust_qty])



    useEffect(() => {

        if (id) {
            dispatch(singleProductAction(id))
        }

    }, [dispatch, id])


    useEffect(() => {
        if (product) {
            setScan_code(product.scan_code)
            setDescription(product.description)
            setUnit_case(product.unit_case)
            setDepartment(product.department)
            setPurchase_qty(product.purchase_qty)
            setSold_qty(product.sold_qty)
            setAdjust_qty(product.adjust_qty)
            setCurrent_qty(product.current_qty)
            seteach_cost(product.each_cost)
            seteach_retail(product.each_retail)
        }

    }, [product])




    return (
        <Fragment>
            <section className="pl-[1.5vmax] pr-[2.5vmax] ]">
                {(loading || singleProductLoading) && <Loader />}
                <div className="flex justify-between items-center bg-white p-[1.2vmax] rounded-[1vmax] px-[2vmax]">
                    <h2 className="text-[1.3vmax] font-bold">Update Product</h2>

                    <div className="flex-center gap-[0.8vmax] text-[1vmax]">
                        <Link to={"/product-catalog"}>Product Catalog</Link>
                        <div className="w-[0.3vmax] h-[0.3vmax] rounded-[50%] bg-black"></div>
                        <span className="text-slate-400">Update Product</span>
                    </div>
                </div>
            </section>


            <section className="pl-[1.5vmax] pr-[2.5vmax] mt-[1vmax] mb-[4vmax]">
                <div className="p-[2vmax] bg-white shadow-1 rounded-2xl">
                    {singleProductError ?
                        <div className="text-[2vmax] font-bold text-center py-[2vmax]">
                            No Product Found with this ID
                        </div>
                        :
                        <form onSubmit={handleSubmit} >
                            <div className="flex justify-between items-center">
                                <div className=" w-[32%] flex flex-col gap-[0.5vmax]">
                                    <span className="text-[1vmax] font-[600] text-gray-600" >UPC Scan Code<span className="text-red-500" >&nbsp;*</span></span>
                                    <input type="text" className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]" placeholder="Scan a Barcode here"
                                        value={scan_code}
                                        onChange={(e) => setScan_code(e.target.value)}
                                    />
                                </div>
                                <div className=" w-[32%] flex flex-col gap-[0.5vmax]">
                                    <span className="text-[1vmax] font-[600] text-gray-600" >Department<span className="text-red-500" >&nbsp;*</span></span>
                                    <input type="text" className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]" placeholder="Product Department"
                                        value={department}
                                        onChange={(e) => setDepartment(e.target.value)}
                                    />
                                </div>
                                <div className=" w-[32%] flex flex-col gap-[0.5vmax]">
                                    <span className="text-[1vmax] font-[600] text-gray-600" >Unit/Case</span>
                                    <input type="number" className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]" placeholder="Product Unit or Case"
                                        value={unit_case}
                                        onChange={(e) => setUnit_case(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="flex justify-between items-center mt-[1.5vmax]">
                                <div className=" w-[65.5%] flex flex-col gap-[0.5vmax]">
                                    <span className="text-[1vmax] font-[600] text-gray-600" >Description<span className="text-red-500" >&nbsp;*</span></span>
                                    <input type="text" className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]" placeholder="Product Description"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                </div>
                                <div className=" w-[32%] flex flex-col gap-[0.5vmax]">
                                    <span className="text-[1vmax] font-[600] text-gray-600" >Purchase Quantity</span>
                                    <input type="number" className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]" placeholder="Product Purchase Quantity"
                                        value={purchase_qty}
                                        onChange={(e) => setPurchase_qty(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="flex justify-between items-center mt-[1.5vmax]">


                                <div className=" w-[32%] flex flex-col gap-[0.5vmax]">
                                    <span className="text-[1vmax] font-[600] text-gray-600" >Sold Quantity</span>
                                    <input type="number" className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]" placeholder="Product Sold Quantity"
                                        value={sold_qty}
                                        onChange={(e) => setSold_qty(e.target.value)}
                                    />
                                </div>
                                <div className=" w-[32%] flex flex-col gap-[0.5vmax]">
                                    <span className="text-[1vmax] font-[600] text-gray-600" >Adjust Quantity</span>
                                    <input type="number" className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]" placeholder="Product Adjust Quantity"
                                        value={adjust_qty}
                                        onChange={(e) => setAdjust_qty(e.target.value)}
                                    />
                                </div>

                                <div className=" w-[32%] flex flex-col gap-[0.5vmax]">
                                    <span className="text-[1vmax] font-[600] text-gray-600" >Current Quantity</span>
                                    <input type="number" className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]" placeholder="Product Current Quantity"
                                        value={current_qty}
                                        onChange={(e) => setCurrent_qty(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="flex justify-between items-center mt-[1.5vmax]">

                                <div className=" w-[32%] flex flex-col gap-[0.5vmax]">
                                    <span className="text-[1vmax] font-[600] text-gray-600" >Cost Price ($)
                                        <span className="text-red-500" >&nbsp;*</span>
                                    </span>
                                    <input type="number" className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]"
                                        placeholder="Product Cost Price "
                                        value={each_cost}
                                        onChange={(e) => seteach_cost(e.target.value)}
                                    />
                                </div>
                                <div className=" w-[32%] flex flex-col gap-[0.5vmax]">
                                    <span className="text-[1vmax] font-[600] text-gray-600" >Retail Price ($)
                                        <span className="text-red-500" >&nbsp;*</span>
                                    </span>
                                    <input type="number" className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]"
                                        placeholder="Product Retail Price"
                                        value={each_retail}
                                        onChange={(e) => seteach_retail(e.target.value)}
                                    />
                                </div>
                                <div className="w-[32%]"></div>

                            </div>
                            <div className="flex justify-between gap-[1vmax] mt-10">
                                <span className="font-[500] text-gray-600 " >
                                    <i class="fa-solid fa-circle-info"></i>
                                    &nbsp;&nbsp;&nbsp;&nbsp;Fields with "<span className="text-red-600" > * </span>" are required</span>
                                <div className="flex gap-[1.5vmax]">

                                    <button className="text-[1.1vmax] bg-green-600 hover:bg-green-700 text-white px-[1vmax] py-[0.5vmax] rounded-lg" type="submit" >Save Product</button>
                                </div>
                            </div>
                        </form>

                    }
                </div>
            </section>
        </Fragment>
    );
};

export default UpdateProduct;
